import {atomWithDefault} from 'jotai/utils';
import {getTaskList} from '../service';

//服务列表
export const taskListAtom = atomWithDefault(async () => {
    return await getTaskList();
});
